/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QualificationTypeModel } from '../../models/qualification-type-model';

export interface QualificationTypeIdGet$Params {
  id: string;
}

export function qualificationTypeIdGet(http: HttpClient, rootUrl: string, params: QualificationTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<QualificationTypeModel>> {
  const rb = new RequestBuilder(rootUrl, qualificationTypeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<QualificationTypeModel>;
    })
  );
}

qualificationTypeIdGet.PATH = '/QualificationType/{id}';
